import React, { useState } from "react";
import { Card, Form, Row, Col, Modal, Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { requiredMessages } from "../../utils/constants";
import { ModalFooterButtons } from "../../shared/components/modalFooterButtons/modalFooterButtons";

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

const AddDocumentAttachment = ({
  showAttachmentModal,
  handelModalClose,
  loadingButton,
  handelSaveAttachment,
}) => {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileList, setFileList] = useState([]);

  const handleUpload = () => {
    if (uploadedFile) {
      const payloadObj = { files: uploadedFile };
      handelSaveAttachment(payloadObj);
    } else {
      message.warning("Inserisci Attachment");
    }
  };

  const beforeUpload = (file) => {
    setUploadedFile(file);
    setFileList([file]); // ✅ Ensure only one file is stored
    return false; // Prevent automatic upload by Ant Design
  };

  const handleChange = (info) => {
    if (info.file.status === "removed") {
      setUploadedFile(null);
      setFileList([]);
    } else {
      setUploadedFile(info.file);
      setFileList([...info.fileList]);
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  const onRemove = () => {
    setUploadedFile(null);
    setFileList([]);
  };

  return (
    <Modal
      width={800}
      title="Aggiungi attachment"
      open={showAttachmentModal}
      //destroyOnClose={true}
      onCancel={handelModalClose}
      footer={[
        <ModalFooterButtons
          key="addDocumentAttachment"
          disabled={!uploadedFile}
          loadingButton={loadingButton}
          modalClose={handelModalClose}
          formId={"addDocumentAttachment"}
        />,
      ]}
    >
      <Card>
        <Form
          id="addDocumentAttachment"
          layout="vertical"
          {...formItemLayout}
          onFinish={handleUpload}
        >
          <Row gutter={{ lg: 24 }} className="row-margin">
            <Col span={24}>
              <Form.Item
                label="Attachment"
                name="file"
                rules={[
                  { required: true, message: requiredMessages.requiredField },
                ]}
              >
                <Upload
                  maxCount={1}
                  beforeUpload={beforeUpload}
                  fileList={fileList}
                  onChange={handleChange}
                  onRemove={onRemove}
                >
                  <Button
                    icon={<UploadOutlined style={{ color: "#438bc9" }} />}
                  >
                    Carica Attachment
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Modal>
  );
};

export default AddDocumentAttachment;
